<template>
    <div :class="wrapperClass">
        <BmvDropdown align="left" :min-width="190" :stretch="variant !== 'v2'">
            <template #trigger="{ open }">
            <button
                type="button"
                v-if="variant === 'v2'"
                :aria-expanded="open ? 'true' : 'false'"
                class="bep-v2-btn"
                :class="{ 'bep-v2-btn--loading': isLoadingPriority }"
                :title="$t(`post.page.priority.${post.priority || 0}`)"
            >
                <i class="fal fa-flag bep-v2-btn-icon" :class="`bep-v2-btn-icon--p${post.priority || 0}`"></i>
                <span class="bep-v2-btn-label">{{ $t(`post.page.priority.${post.priority || 0}`) }}</span>
                <i v-if="isLoadingPriority" class="fas fa-circle-notch fa-spin bep-v2-btn-spin"></i>
                <i v-else class="fal fa-chevron-down bep-v2-btn-caret"></i>
            </button>

            <button
                type="button"
                v-else
                :aria-expanded="open ? 'true' : 'false'"
                :class="{
                    'bg-indigo-500 hover:bg-indigo-700 focus:ring-indigo-500':
                        post.priority === null || post.priority === 0,
                    'bg-green-600 hover:bg-green-700 focus:ring-green-500':
                        post.priority === 1,
                    'bg-blue-600 hover:bg-blue-700 focus:ring-blue-500':
                        post.priority === 2,
                    'bg-yellow-600 hover:bg-yellow-700 focus:ring-yellow-500':
                        post.priority === 3,
                    'bg-red-600 hover:bg-red-700 focus:ring-red-500':
                        post.priority === 4
                }"
                class="w-full inline-flex items-center px-2 border border-transparent shadow-sm text-sm leading-4 font-medium rounded-md text-white focus:outline-none focus:ring-2 focus:ring-offset-2 justify-content-between"
            >
                <div class="inline-flex items-center py-2">
                    <div v-if="post.priority === null || post.priority === 0">
                        <IconBolt class="-ml-0.5 mr-2 h-4 w-6" />
                    </div>
                    <div v-if="post.priority === 1">
                        <IconSearch class="-ml-0.5 mr-2 h-4 w-4" />
                    </div>
                    <div v-if="post.priority === 2">
                        <IconCheck class="-ml-0.5 mr-2 h-4 w-4" />
                    </div>
                    <div v-if="post.priority === 3">
                        <IconProgress class="-ml-0.5 mr-2 h-4 w-4" />
                    </div>
                    <div v-if="post.priority === 4">
                        <IconFire class="-ml-0.5 mr-2 h-4 w-4" />
                    </div>
                    {{ $t(`post.page.priority.${post.priority}`) }}
                    <i
                        v-if="isLoadingPriority === true"
                        class="fas fa-circle-notch fa-spin ml-2 text-white"
                    ></i>
                </div>
                <svg
                    class="ml-2 w-4 h-4"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M19 9l-7 7-7-7"
                    ></path>
                </svg>
            </button>
            </template>

            <div :class="{ 'bep-menu--loading': isLoadingPriority }">
                <a
                    v-for="(priority, index) in [0, 1, 2, 3, 4]"
                    :key="index"
                    class="dropdown-item d-flex w-100 justify-center pr-4"
                    @click.prevent="postPriority(post, priority)"
                >
                    <span class="mr-auto">{{
                        $t(`post.page.priority.${priority}`)
                    }}</span>

                    <span
                        v-if="priority === post.priority"
                        class="ml-auto status status-success mt-1.5"
                    ></span>
                </a>
            </div>
        </BmvDropdown>
    </div>
</template>
<style scoped>
.bep-menu--loading {
    opacity: 0.6;
    pointer-events: none;
}

.bep-v2-btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    height: 32px;
    padding: 0 12px;
    border: 1px solid var(--v2-border);
    border-radius: var(--v2-radius-sm);
    background: var(--v2-surface-0);
    font: inherit;
    font-size: 0.82rem;
    font-weight: var(--v2-font-weight-medium);
    line-height: 1.2;
    color: var(--v2-text-2);
    white-space: nowrap;
    cursor: pointer;
    transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
    box-sizing: border-box;
    -webkit-appearance: none;
    appearance: none;
    outline: none;
}

.bep-v2-btn:hover:not(:disabled) {
    background: var(--v2-surface-2);
    color: var(--v2-text-1);
}

.bep-v2-btn:focus-visible {
    outline: none;
    box-shadow: 0 0 0 3px rgba(8, 145, 178, 0.25);
}

.bep-v2-btn-icon {
    font-size: 0.8rem;
}

.bep-v2-btn-icon--p0 { color: var(--v2-text-4); }
.bep-v2-btn-icon--p1 { color: #2563eb; }
.bep-v2-btn-icon--p2 { color: #047857; }
.bep-v2-btn-icon--p3 { color: #b45309; }
.bep-v2-btn-icon--p4 { color: #b91c1c; }

.bep-v2-btn-caret {
    font-size: 0.7rem;
    margin-left: 2px;
    color: var(--v2-text-4);
    opacity: 0.9;
}

.bep-v2-btn-spin {
    font-size: 0.8rem;
}

.bep-v2-btn--loading {
    opacity: 0.75;
    pointer-events: none;
}

@media (max-width: 900px) {
    .bep-v2-btn {
        padding: 0 10px;
    }

    .bep-v2-btn-label {
        display: none;
    }
}
</style>
<script>
/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
import { mapActions } from 'vuex'
import BmvDropdown from '@/components/UI/v2/BmvDropdown.vue'

export default {
    name: 'ButtonEditPriority',
    components: { BmvDropdown },
    props: ['post', 'variant'],
    data: function () {
        return {
            isLoadingPriority: false
        }
    },
    computed: {
        wrapperClass() {
            const isV2 = this.variant === 'v2'
            return {
                'dropdown': true,
                'w-full': !isV2,
                'h-full': !isV2,
                'lg:w-1/4': this.variant === 'minimal',
                'md:w-1/4': this.variant === 'minimal'
            }
        }
    },
    methods: {
        ...mapActions('post', ['updatePriority', 'getPostHistories']),
        postPriority(post, priority) {
            if (
                this.isLoadingPriority === true ||
                this.post.priority === priority
            ) {
                return
            }
            var updatedPriority = {
                id: post.id,
                priority: priority
            }
            this.isLoadingPriority = true

            this.updatePriority(updatedPriority)
                .then(() => {
                    this.getPostHistories(post.id)
                    post.priority = updatedPriority.priority
                })
                .finally(() => {
                    this.isLoadingPriority = false
                })
        }
    }
}
</script>
